/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { Tooltip } from 'antd';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from './index';

const hasValueChangedFromOriginal = (currentValue, originalValue) =>
  Number(currentValue ?? 0) !== Number(originalValue ?? 0);

function InputWithChangedValue({ value, originalValue, showIndicator, ...inputProps }) {
  const shouldShowIndicator =
    showIndicator && originalValue != null && hasValueChangedFromOriginal(value, originalValue);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <Input
        value={value}
        {...inputProps}
      />
      {shouldShowIndicator && (
        <Tooltip title={`Valor alterado! (era ${moneyFormat(originalValue)})`}>
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            size="sm"
            style={{ color: '#FAAD14', flexShrink: 0 }}
          />
        </Tooltip>
      )}
    </span>
  );
}

InputWithChangedValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  originalValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showIndicator: PropTypes.bool,
  getValue: PropTypes.func,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  prefix: PropTypes.string,
};

InputWithChangedValue.defaultProps = {
  value: undefined,
  originalValue: undefined,
  showIndicator: false,
  getValue: undefined,
  disabled: false,
  min: undefined,
  prefix: undefined,
};

export default InputWithChangedValue;
